const COMMENTS = [
  {
    name: '老电影迷阿强',
    date: '3天前',
    rating: 5,
    content: '90影院真的是宝藏网站！港片专区太全了，连很多冷门老片都有4K修复版，画质比我以前找的资源好太多了。周星驰全集我已经三刷了，每次看都有新感受。',
    tag: '港片爱好者',
  },
  {
    name: '追剧少女小美',
    date: '1周前',
    rating: 5,
    content: '更新速度超快！《繁花》刚播完第二天就有超清全集了，播放也很流畅，地铁上追剧完全不卡。已经把90影院推荐给身边所有追剧的姐妹了。',
    tag: '国产剧迷',
  },
  {
    name: '动漫老二次元',
    date: '5天前',
    rating: 4,
    content: '海贼王、火影、进击的巨人全部都有，而且更新跟日本同步，太良心了！希望后续能多加一些经典老番，比如《星际牛仔》《攻壳机动队》这些。',
    tag: '日漫粉丝',
  },
  {
    name: '纪录片控大刘',
    date: '2周前',
    rating: 5,
    content: 'BBC、国家地理、Discovery的纪录片资源很丰富，4K画质下看《地球脉动》简直是一场视觉盛宴。分类也很清晰，找片很方便，强烈推荐！',
    tag: '纪录爱好者',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">观众热评</h2>
            <p className="mt-2 text-sm text-foreground-500">来自真实用户的观影体验与评价</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
            {COMMENTS.map((comment, i) => (
              <div
                key={i}
                className="p-5 rounded-xl bg-background-50 border border-background-200/60"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <span className="font-heading text-sm font-bold text-primary-600">
                      {comment.name.charAt(0)}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="text-sm font-semibold text-foreground-900">{comment.name}</h3>
                      <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-secondary-100 text-secondary-700">
                        {comment.tag}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 mt-1">
                      <div className="flex items-center gap-0.5">
                        {Array.from({ length: 5 }).map((_, j) => (
                          <i
                            key={j}
                            className={`ri-star-fill text-xs ${j < comment.rating ? 'text-primary-500' : 'text-foreground-300'}`}
                          ></i>
                        ))}
                      </div>
                      <span className="text-xs text-foreground-400">{comment.date}</span>
                    </div>
                  </div>
                </div>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}